<div class="pagination-displayed-wrapper">
  <cm-pagination-displayed
  class="pagination-displayed"
  [collectionSize]="collectionSize"
  [page]="page"
  [pageSize]="pageSize">
</cm-pagination-displayed>
<cm-pagination-page-size-selector
  *ngIf="pageSizeSelectorActive"
  class="page-size-selector"
  [collectionSize]="collectionSize"
  [pageSize]="pageSize"
  (pageSizeChange)='pageSizeChange.emit($event)'>
</cm-pagination-page-size-selector>
</div>
<cm-pagination
  class="pagination"
  [collectionSize]="collectionSize"
  [page]="page"
  [maxSize]="maxSize"
  [pageSize]="pageSize"
  (pageChange)="pageChange.emit($event)">
</cm-pagination>
<div class="content">
  <ng-content></ng-content>
</div>
